import type { AdditionalInformation } from 'typings'

/*
 * Maps the key-value { [key: string]: string } object
 * received from the API into an array of objects
 * of type `AdditionalInformaton` ({ name: string, value: string })
 *
 * Example:
 * {
 *    "entryName": "entryValue",
 *    "entryName2": "entryValue2"
 * }
 *
 * is transformed into
 *
 * [
 *    { name: "entryName", value: "entryValue" },
 *    { name: "entryName2", value: "entryValue2" }
 * ]
 *
 */
export function mapAdditionalInformation(
  values: Record<string, string> | undefined
): AdditionalInformation[] {
  return Object.entries(values ?? {}).reduce<AdditionalInformation[]>(
    (acc, [name, value]) => [...acc, { name, value }],
    []
  )
}
